export default __webpack_public_path__ + "static/zonapro-bold-b4f02c1d0c5aa5c2ef8e28ea9cbd9020.eot";